import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CheckCircle2, Lock, Download } from 'lucide-react';
export function OfferSection() {
  return <Section id="offer" background="alt" className="pb-32" data-id="element-92">
      <div className="max-w-3xl mx-auto text-center" data-id="element-93">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-[#E5E0D6]" data-id="element-94">
          {/* Header */}
          <div className="bg-[#1A5F5A] text-white p-8" data-id="element-95">
            <h2 className="text-3xl font-bold font-serif mb-2" data-id="element-96">
              Rodillas Fuertes 65+
            </h2>
            <p className="text-[#E8F2F1] opacity-90" data-id="element-97">
              El método completo de 14 días
            </p>
          </div>

          {/* Body */}
          <div className="p-8 md:p-12" data-id="element-98">
            {/* Discount Badge */}
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#C96B4B]/10 text-[#C96B4B] text-sm font-bold mb-4" data-id="element-99">
              🔥 Oferta especial - 64% OFF
            </div>

            <div className="flex justify-center items-baseline mb-2" data-id="element-100">
              <span className="text-2xl text-[#4A4A4A] line-through mr-3" data-id="element-101">
                $19
              </span>
              <span className="text-5xl font-bold text-[#2D2D2D]" data-id="element-102">$6.90</span>
              <span className="text-xl text-[#4A4A4A] ml-2" data-id="element-103">USD</span>
            </div>

            <p className="text-sm text-[#C96B4B] font-medium mb-8" data-id="element-104">
              Ahorras $12.10 con esta oferta especial
            </p>

            <div className="space-y-4 text-left max-w-md mx-auto mb-10" data-id="element-105">
              {['PDF Completo del Programa (14 días)', 'Guía visual de ejercicios paso a paso', 'Semáforo del Dolor (Herramienta)', 'Plan de Mantención de por vida', 'Acceso inmediato digital'].map((item, i) => <div key={i} className="flex items-center" data-id="element-106">
                  <CheckCircle2 className="w-5 h-5 text-[#C96B4B] mr-3 shrink-0" data-id="element-107" />
                  <span className="text-[#2D2D2D] font-medium" data-id="element-108">{item}</span>
                </div>)}
            </div>

            <Button size="lg" fullWidth className="text-lg py-6 shadow-xl shadow-[#C96B4B]/20 mb-4" data-id="element-109">
              <Download className="mr-2 h-5 w-5" data-id="element-110" />
              Descarga ahora y empieza el Día 1
            </Button>

            <div className="flex items-center justify-center text-sm text-[#4A4A4A] gap-2" data-id="element-111">
              <Lock className="w-4 h-4" data-id="element-112" />
              <span data-id="element-113">Pago seguro y encriptado</span>
            </div>
          </div>
        </div>

        {/* Final Emotional Close */}
        <div className="mt-16 max-w-2xl mx-auto" data-id="element-114">
          <p className="text-xl md:text-2xl text-[#2D2D2D] font-serif italic leading-relaxed" data-id="element-115">
            "No es solo caminar más. Es volver a decir 'sí' sin negociar con tu
            rodilla: sí al mandado, sí al parque, sí a visitar a alguien, sí a
            salir sin estar calculando dónde sentarte."
          </p>
        </div>
      </div>
    </Section>;
}